import { createReducer } from 'actionware';
import { createState } from 'stateware';
import { toggleWithdrawalModal, setOtherForm, setFailedWithdrawal } from './withdrawalActions';

const initialState = createState({
  showingWithdrawalModal: false,
  otherForm: false,
  failedWithdrawal: false
});

export default createReducer(initialState)
  .on(toggleWithdrawalModal, (state) =>
    initialState.copy({
      showingWithdrawalModal: !state.showingWithdrawalModal,
      otherForm: state.otherForm,
      failedWithdrawal: state.failedWithdrawal
    })
  )
  .on(setOtherForm, (state, data) =>
    initialState.copy({
      showingWithdrawalModal: state.showingWithdrawalModal,
      otherForm: data,
      failedWithdrawal: state.failedWithdrawal
    })
  )
  .on(setFailedWithdrawal, (state) =>
    initialState.copy({
      showingWithdrawalModal: state.showingWithdrawalModal,
      otherForm: state.otherForm,
      failedWithdrawal: true
    })
  );
